import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce, isEmpty, uniqueId } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    prompt: {
      type: String,
      default: ""
    },
    promptHTML: {
      type: String,
      default: ""
    },
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: null,
      default: () => ({
        option: "",
        text: ""
      })
    },
    explainLabel: {
      type: String,
      default: ""
    },
    maxlength: {
      type: String,
      default: ""
    },
    maxrows: {
      type: String,
      default: "3"
    },
    resize: {
      type: String,
      default: "none"
    },
    extraOptions: {
      type: Array,
      default: () => []
    },
    valuesToDisable: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      option: this.value.option,
      text: this.value.text,
      id: uniqueId()
    };
  },
  computed: {
    computedExplainLabel() {
      return this.explainLabel || this.$t("global.words.ifYesExplain");
    },
    shouldDisableInput() {
      const valuesToDisable = this.valuesToDisable || ["0", "2"];
      return _includesInstanceProperty(valuesToDisable).call(valuesToDisable, this.option) || isEmpty(this.option);
    }
  },
  watch: {
    text(value, oldValue) {
      const currentRows = this.validateMaxRows(value);
      this.text = currentRows >= _parseInt(this.maxrows) ? oldValue : value;
    }
  },
  methods: {
    validateMaxRows(inputString) {
      return (inputString.match(/\n/g) || []).length;
    },
    handleChange: debounce(function () {
      if (this.shouldDisableInput) {
        this.text = "";
      }
      this.$emit("input", {
        option: this.option,
        text: this.text || ""
      });
    }, 500)
  }
});